export default "__VITE_ASSET__CWUFlead__"